import { createFeatureSelector, createSelector } from '@ngrx/store';
import { UsersState } from '../reducers/users.reducer';
import { USERS_FEATURE_KEY } from '../keys';

const selectState = createFeatureSelector<UsersState>(USERS_FEATURE_KEY);

export const selectLoaded = createSelector(selectState, (state: UsersState) => state.loaded);
export const selectLoading = createSelector(selectState, (state: UsersState) => state.loading);
export const selectUsers = createSelector(selectState, (state: UsersState) => state.users);
